import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import { GetMarathonWithDistancesParams, GetMarathonWithDistancesResponse } from "api/api/marathonsApi/types";

export const getMarathonWithDistances = createAsyncThunk<
  GetMarathonWithDistancesResponse,
  GetMarathonWithDistancesParams
>(
  "marathons/getMarathonWithDistances",
  async ({ marathonId }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMarathonWithDistances({ marathonId });
      return data;
    } catch (error: any) {
      console.error("Error while getting marathon details", error);
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  })